module.exports = __webpack_public_path__ + "b8c5fd7d4dbba21ce47bf3c2adcd8244.png";